<template>
  <span :style="badgeStyle">
    <span :style="{ color: textColor }">{{ text }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: { type: String, required: true },
  textColor: { type: String, required: true },
  fillColor: { type: String, required: true }
})

const badgeStyle = computed(() => ({
  display: 'inline-block',
  width: '60px',
  paddingRight: '6px',
  paddingLeft: '6px',
  fontSize: '12px',
  backgroundColor: props.fillColor,
  borderRadius: '6%',
  whiteSpace: 'nowrap!important',
  overflow: 'hidden!important',
  textOverflow: 'ellipsis!important',
}))
</script>

<style scoped>
/* Add any component-specific styling here */
</style>
